module.exports = __webpack_public_path__ + "img/ico-arrow-down-color.f1753fad.svg";